import type { StopType } from '#domain/Stop.ts';
import type { AddressTypes } from '#features/orderForm/ui/LocationForm.tsx';

export const mapStopTypeToAddressType = (stopType?: StopType): AddressTypes => {
    if (stopType === 'load') {
        return 'loadingStop';
    }
    if (stopType === 'execute') {
        return 'executionStop';
    }
    return 'unloadingStop';
};
